import { Component, Input } from '@angular/core';

interface TeamInfo {
  teamName: string;
  leaderName: string;
}
@Component({
  selector: 'app-rrhh-import-team',
  templateUrl: './rrhh-import-team.component.html',
  styleUrls: ['./rrhh-import-team.component.scss']
})
export class RrhhImportTeamComponent {
  @Input() value!: TeamInfo;
}
